interface Props {
  value: string
  lastOdometer: number
  onChange: (v: string) => void
}

export default function OdometerInput({ value, lastOdometer, onChange }: Props) {
  const num = parseInt(value, 10)
  const warn = !isNaN(num) && lastOdometer > 0 && num < lastOdometer

  return (
    <div className="field">
      <label htmlFor="odometer">目前里程（km）</label>
      <input
        id="odometer"
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder={lastOdometer > 0 ? String(lastOdometer) : '選填'}
        value={value}
        onChange={e => onChange(e.target.value.replace(/\D/g, ''))}
        autoComplete="off"
      />
      {warn && (
        <p className="field-warn">
          輸入值比上次里程（{lastOdometer.toLocaleString()} km）小，確認是否打錯？
        </p>
      )}
    </div>
  )
}
